// this component is inspired by Quasar QAjaxbar
<template>
  <v-progress-linear
    :active="!!calls"
    indeterminate
    absolute
    color="deep-orange"
  />
</template>

<script>

const xhr = XMLHttpRequest
const send = xhr.prototype.send
const stackStart = []
const stackStop = []

let ajaxCount = 0

function ajaxCall (start, stop) {
  stackStart.push(start)
  stackStop.push(stop)

  ajaxCount++

  if (ajaxCount > 1) { return }

  function endHandler () {
    stackStop.forEach(fn => { fn() })
  }

  xhr.prototype.send = function (/* ...args */) {
    stackStart.forEach(fn => { fn() })
    this.addEventListener('loadend', endHandler, false)
    send.apply(this, arguments)
  }
}

function restoreAjax (start, stop) {
  stackStart.splice(stackStart.indexOf(start), 1)
  stackStop.splice(stackStop.indexOf(stop), 1)

  ajaxCount = Math.max(0, ajaxCount - 1)
  if (!ajaxCount) {
    xhr.prototype.send = send
  }
}

export default {
  data () {
    return {
      calls: 0
    }
  },
  mounted () {
    ajaxCall(this.start, this.end)
  },
  beforeDestroy () {
    restoreAjax()
  },
  methods: {
    start () {
      this.calls++
    },
    end () {
      this.calls--
    }
  }
}
</script>
